import { AxiosInstance } from 'axios';

import { BaseAuthenticatedClient } from '.';
import { BaseDataResponse, BaseResponse } from '../responses';
import { RoomModel } from '../interfaces';
import { IAuthenticatedRequestHandler, IErrorHandler } from '../abstractions';

export default class RoomClient extends BaseAuthenticatedClient {
  constructor(authenticatedRequestHandler: IAuthenticatedRequestHandler, errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
    super(authenticatedRequestHandler, errorHandler, axiosInstance, 'room');
  }

  public async getAllAsync(): Promise<BaseDataResponse<RoomModel[]>> {
    return await this.getHttpAsync<BaseDataResponse<RoomModel[]>>('', '');
  }

  public async createAsync(model: RoomModel): Promise<BaseDataResponse<RoomModel>> {
    return await this.postHttpAsync<BaseDataResponse<RoomModel>, RoomModel>('', model);
  }

  public async updateAsync(model: RoomModel): Promise<BaseDataResponse<RoomModel>> {
    return await this.putHttpAsync<BaseDataResponse<RoomModel>, RoomModel>(`${model.id}`, model);
  }

  public async deleteAsync(id: number): Promise<BaseResponse> {
    return await this.deleteHttpAsync<BaseResponse>(`${id}`);
  }
}
